// Allow-list, not a deny-list: `erp.labor_ticket.type` has no CHECK constraint,
// so casing is a convention. Normalizing matters -- an unnormalized 'Indirect'
// falls through to the job branch and opens the production form (parts, start
// quantity, job status), none of which apply to indirect labor.
// Mirrored in labor-ticket-form utils/constants.js, operator-kiosk
// utils/laborTicketTypes.js, Dashboard indirectLabor.service.js and Data Studio
// laborTicketTypes.js. Keep in step.
export const INDIRECT_LABOR_TICKET_TYPE = 'indirect';

const INDIRECT_LABOR_TICKET_TYPES = [INDIRECT_LABOR_TICKET_TYPE];

export function isIndirectLaborTicketType(value) {
  return (
    typeof value === 'string' &&
    INDIRECT_LABOR_TICKET_TYPES.includes(value.toLowerCase().trim())
  );
}

export function isIndirectTicket(ticket) {
  return isIndirectLaborTicketType(ticket?.type);
}
